export default __webpack_public_path__ + "static/media/tete2.09571866.png";